<template>
    <section class="row sdj-speak-to-us">
      <div class="col-10 offset-1">
        <h2 class="sdk-title-section agp-normal mb-20px">Speak To Us</h2>
        <div class="inner-speak-to-us">
          <ul class="display_flex">
            <li v-for="(item, index) in data" :key="index">
              <img class="speak-icon" :src="item.icon" alt="" />
              <h5 v-html="item.title"></h5>
              <span v-if="item.link" v-html="formatLink(item.link)"></span>
            </li>
          </ul>
        </div>
      </div>
    </section>
</template>
  
<script setup lang="ts">
  import { defineProps } from 'vue';
  
  // Define the structure of the prop data
  interface SpeakToUsItem {
    icon: string;
    title: string;
    link?: string; // Optional field for link
  }

  function formatLink(link: string): string {
    // Check if the link contains encoded characters that represent an invalid anchor tag
    if (link.includes("LiveChatWidget.call")) {
        // Manually replace the encoded link with proper href and onclick
        return `<a href="/" onclick="LiveChatWidget.call('maximize'); return false;"></a>`;
    }
    // Return the original link if it doesn't need fixing
    return link;
    }
  
  // Define props that will be passed from the parent or fetched via an API
  const props = defineProps<{
    data: SpeakToUsItem[];
  }>();
  
</script>

<style scoped>

</style>